import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ChangePasswordDto,
  EditUserDto,
  RegisterUserDto,
  UserDto,
} from '../dto';

@Injectable()
export class UsersApiService {
  private http = inject(HttpClient);

  private route = 'users';

  getUserProfile(): Observable<UserDto> {
    return this.http.get<UserDto>(`${this.route}/profile`);
  }

  registerUser(user: RegisterUserDto): Observable<UserDto> {
    return this.http.post<UserDto>(`${this.route}/register`, user);
  }

  updateUserProfile(user: EditUserDto): Observable<void> {
    return this.http.patch<void>(`${this.route}/profile`, user);
  }

  changePassword(data: ChangePasswordDto): Observable<void> {
    return this.http.post<void>(`${this.route}/change-password`, data);
  }

  editProfileImage(image: FormData): Observable<void> {
    return this.http.post<void>(`${this.route}/profile/picture`, image);
  }

  deleteProfileImage(): Observable<void> {
    return this.http.delete<void>(`${this.route}/profile/picture`);
  }
}
